export default "__VITE_ASSET__BW9IS5h8__"